type Country = {
  countryName: string;
  countryCode: string;
  dialCode: number;
  regexpPhone: RegExp | undefined;
  priority: number;
  areaCodes: number[];
  translations: {
    dk: string;
    en: string;
    sv: string;
    no: string;
  };
};

export const countryList: Country[] = [
  {
    countryName: 'Afghanistan (افغانستان)',
    countryCode: 'af',
    translations: {
      dk: 'Afghanistan',
      en: 'Afghanistan',
      sv: 'Afghanistan',
      no: 'Afghanistan',
    },
    dialCode: 93,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Albania (Shqipëri)',
    countryCode: 'al',
    translations: {
      dk: 'Albanien',
      en: 'Albania',
      sv: 'Albanien',
      no: 'Albania',
    },
    dialCode: 355,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Algeria (الجزائر)',
    countryCode: 'dz',
    translations: {
      dk: 'Algeriet',
      en: 'Algeria',
      sv: 'Algeriet',
      no: 'Algerie',
    },
    dialCode: 213,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'American Samoa',
    countryCode: 'as',
    translations: {
      dk: 'Amerikansk Samoa',
      en: 'American Samoa',
      sv: 'Amerikanska Samoa',
      no: 'Amerikansk Samoa',
    },
    dialCode: 1,
    areaCodes: [684],
    priority: 5,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Andorra',
    countryCode: 'ad',
    translations: {
      dk: 'Andorra',
      en: 'Andorra',
      sv: 'Andorra',
      no: 'Andorra',
    },
    dialCode: 376,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{6}$/,
  },
  {
    countryName: 'Angola',
    countryCode: 'ao',
    translations: {
      dk: 'Angola',
      en: 'Angola',
      sv: 'Angola',
      no: 'Angola',
    },
    dialCode: 244,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Anguilla',
    countryCode: 'ai',
    translations: {
      dk: 'Anguilla',
      en: 'Anguilla',
      sv: 'Anguilla',
      no: 'Anguilla',
    },
    dialCode: 1,
    areaCodes: [264],
    priority: 6,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Antigua and Barbuda',
    countryCode: 'ag',
    translations: {
      dk: 'Antigua og Barbuda',
      en: 'Antigua and Barbuda',
      sv: 'Antigua och Barbuda',
      no: 'Antigua og Barbuda',
    },
    dialCode: 1,
    areaCodes: [268],
    priority: 7,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Argentina',
    countryCode: 'ar',
    translations: {
      dk: 'Argentina',
      en: 'Argentina',
      sv: 'Argentina',
      no: 'Argentina',
    },
    dialCode: 54,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Armenia (Հայաստան)',
    countryCode: 'am',
    translations: {
      dk: 'Armenien',
      en: 'Armenia',
      sv: 'Armenien',
      no: 'Armenia',
    },
    dialCode: 374,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Aruba',
    countryCode: 'aw',
    translations: {
      dk: 'Aruba',
      en: 'Aruba',
      sv: 'Aruba',
      no: 'Aruba',
    },
    dialCode: 297,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Ascension Island',
    countryCode: 'ac',
    translations: {
      dk: 'Ascension Island',
      en: 'Ascension Island',
      sv: 'Ascension Island',
      no: 'Ascension Island',
    },
    dialCode: 247,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{5}$/,
  },
  {
    countryName: 'Australia',
    countryCode: 'au',
    translations: {
      dk: 'Australien',
      en: 'Australia',
      sv: 'Australien',
      no: 'Australia',
    },
    dialCode: 61,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Austria (Österreich)',
    countryCode: 'at',
    translations: {
      dk: 'Østrig',
      en: 'Austria',
      sv: 'Österrike',
      no: 'Østerrike',
    },
    dialCode: 43,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Azerbaijan (Azərbaycan)',
    countryCode: 'az',
    translations: {
      dk: 'Aserbajdsjan',
      en: 'Azerbaijan',
      sv: 'Azerbajdzjan',
      no: 'Aserbajdsjan',
    },
    dialCode: 994,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Bahamas',
    countryCode: 'bs',
    translations: {
      dk: 'Bahamas',
      en: 'Bahamas',
      sv: 'Bahamas',
      no: 'Bahamas',
    },
    dialCode: 1,
    areaCodes: [242],
    priority: 8,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Bahrain (البحرين)',
    countryCode: 'bh',
    translations: {
      dk: 'Bahrain',
      en: 'Bahrain',
      sv: 'Bahrain',
      no: 'Bahrain',
    },
    dialCode: 973,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Bangladesh (বাংলাদেশ)',
    countryCode: 'bd',
    translations: {
      dk: 'Bangladesh',
      en: 'Bangladesh',
      sv: 'Bangladesh',
      no: 'Bangladesh',
    },
    dialCode: 880,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Barbados',
    countryCode: 'bb',
    translations: {
      dk: 'Barbados',
      en: 'Barbados',
      sv: 'Barbados',
      no: 'Barbados',
    },
    dialCode: 1,
    areaCodes: [246],
    priority: 9,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Belarus (Беларусь)',
    countryCode: 'by',
    translations: {
      dk: 'Hviderusland',
      en: 'Belarus',
      sv: 'Vitryssland',
      no: 'Hviterussland',
    },
    dialCode: 375,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Belgium (België)',
    countryCode: 'be',
    translations: {
      dk: 'Belgien',
      en: 'Belgium',
      sv: 'Belgien',
      no: 'Belgia',
    },
    dialCode: 32,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Belize',
    countryCode: 'bz',
    translations: {
      dk: 'Belize',
      en: 'Belize',
      sv: 'Belize',
      no: 'Belize',
    },
    dialCode: 501,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Benin (Bénin)',
    countryCode: 'bj',
    translations: {
      dk: 'Benin',
      en: 'Benin',
      sv: 'Benin',
      no: 'Benin',
    },
    dialCode: 229,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Bermuda',
    countryCode: 'bm',
    translations: {
      dk: 'Bermuda',
      en: 'Bermuda',
      sv: 'Bermuda',
      no: 'Bermuda',
    },
    dialCode: 1,
    areaCodes: [441],
    priority: 10,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Bhutan (འབྲུག)',
    countryCode: 'bt',
    translations: {
      dk: 'Bhutan',
      en: 'Bhutan',
      sv: 'Bhutan',
      no: 'Bhutan',
    },
    dialCode: 975,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Bolivia',
    countryCode: 'bo',
    translations: {
      dk: 'Bolivia',
      en: 'Bolivia',
      sv: 'Bolivia',
      no: 'Bolivia',
    },
    dialCode: 591,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Bosnia and Herzegovina (Босна и Херцеговина)',
    countryCode: 'ba',
    translations: {
      dk: 'Bosnien og Hercegovina',
      en: 'Bosnia and Herzegovina',
      sv: 'Bosnien och Hercegovina',
      no: 'Bosnia og Hercegovina',
    },
    dialCode: 387,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Botswana',
    countryCode: 'bw',
    translations: {
      dk: 'Botswana',
      en: 'Botswana',
      sv: 'Botswana',
      no: 'Botswana',
    },
    dialCode: 267,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Brazil (Brasil)',
    countryCode: 'br',
    translations: {
      dk: 'Brasilien',
      en: 'Brazil',
      sv: 'Brasilien',
      no: 'Brasil',
    },
    dialCode: 55,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{11}$/,
  },
  {
    countryName: 'British Indian Ocean Territory',
    countryCode: 'io',
    translations: {
      dk: 'Britisk Det Indiske Ocean Territorium',
      en: 'British Indian Ocean Territory',
      sv: 'Brittiska Indiska Oceanterritoriet',
      no: 'Britiske Det Indiske Hav Territorium',
    },
    dialCode: 246,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'British Virgin Islands',
    countryCode: 'vg',
    translations: {
      dk: 'De Britiske Jomfruøer',
      en: 'British Virgin Islands',
      sv: 'Brittiska Jungfruöarna',
      no: 'Britiske Jomfruøyene',
    },
    dialCode: 1,
    areaCodes: [284],
    priority: 11,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Brunei',
    countryCode: 'bn',
    translations: {
      dk: 'Brunei',
      en: 'Brunei',
      sv: 'Brunei',
      no: 'Brunei',
    },
    dialCode: 673,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Bulgaria (България)',
    countryCode: 'bg',
    translations: {
      dk: 'Bulgarien',
      en: 'Bulgaria',
      sv: 'Bulgarien',
      no: 'Bulgaria',
    },
    dialCode: 359,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Burkina Faso',
    countryCode: 'bf',
    translations: {
      dk: 'Burkina Faso',
      en: 'Burkina Faso',
      sv: 'Burkina Faso',
      no: 'Burkina Faso',
    },
    dialCode: 226,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Burundi (Uburundi)',
    countryCode: 'bi',
    translations: {
      dk: 'Burundi',
      en: 'Burundi',
      sv: 'Burundi',
      no: 'Burundi',
    },
    dialCode: 257,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Cambodia (កម្ពុជា)',
    countryCode: 'kh',
    translations: {
      dk: 'Cambodja',
      en: 'Cambodia',
      sv: 'Kambodja',
      no: 'Kambodsja',
    },
    dialCode: 855,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Cameroon (Cameroun)',
    countryCode: 'cm',
    translations: {
      dk: 'Cameroun',
      en: 'Cameroon',
      sv: 'Kamerun',
      no: 'Kamerun',
    },
    dialCode: 237,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Canada',
    countryCode: 'ca',
    translations: {
      dk: 'Canada',
      en: 'Canada',
      sv: 'Kanada',
      no: 'Canada',
    },
    dialCode: 1,
    areaCodes: [
      204, 226, 236, 249, 250, 289, 306, 343, 365, 387, 403, 416, 418, 431, 437, 438, 450, 506, 514, 519, 548, 579, 581, 587, 604, 613, 639, 647, 672, 705, 709, 742, 778, 780, 782,
      807, 819, 825, 867, 873, 902, 905,
    ],
    priority: 1,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Cape Verde (Kabu Verdi)',
    countryCode: 'cv',
    translations: {
      dk: 'Kap Verde',
      en: 'Cape Verde',
      sv: 'Kap Verde',
      no: 'Kapp Verde',
    },
    dialCode: 238,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Caribbean Netherlands',
    countryCode: 'bq',
    translations: {
      dk: 'Caribisk Nederlandene',
      en: 'Caribbean Netherlands',
      sv: 'Karibiska Nederländerna',
      no: 'Karibiske Nederland',
    },
    dialCode: 599,
    areaCodes: [3, 4, 7],
    priority: 1,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Cayman Islands',
    countryCode: 'ky',
    translations: {
      dk: 'Caymanøerne',
      en: 'Cayman Islands',
      sv: 'Caymanöarna',
      no: 'Caymanøyene',
    },
    dialCode: 1,
    areaCodes: [345],
    priority: 12,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Central African Republic (République centrafricaine)',
    countryCode: 'cf',
    translations: {
      dk: 'Centralafrikanske Republik',
      en: 'Central African Republic',
      sv: 'Centralafrikanska republiken',
      no: 'Den sentralafrikanske republikk',
    },
    dialCode: 236,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Chad (Tchad)',
    countryCode: 'td',
    translations: {
      dk: 'Tchad',
      en: 'Chad',
      sv: 'Tchad',
      no: 'Tsjad',
    },
    dialCode: 235,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Chile',
    countryCode: 'cl',
    translations: {
      dk: 'Chile',
      en: 'Chile',
      sv: 'Chile',
      no: 'Chile',
    },
    dialCode: 56,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'China (中国)',
    countryCode: 'cn',
    translations: {
      dk: 'Kina',
      en: 'China',
      sv: 'Kina',
      no: 'Kina',
    },
    dialCode: 86,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{11}$/,
  },
  {
    countryName: 'Christmas Island',
    countryCode: 'cx',
    translations: {
      dk: 'Juleøen',
      en: 'Christmas Island',
      sv: 'Julön',
      no: 'Christmas Island',
    },
    dialCode: 61,
    areaCodes: [89164],
    priority: 2,
    regexpPhone: /^[0-9]{5}$/,
  },
  {
    countryName: 'Cocos (Keeling) Islands',
    countryCode: 'cc',
    translations: {
      dk: 'Cocosøerne',
      en: 'Cocos (Keeling) Islands',
      sv: 'Cocosöarna',
      no: 'Cocosøyene',
    },
    dialCode: 61,
    areaCodes: [89162],
    priority: 1,
    regexpPhone: /^[0-9]{5}$/,
  },
  {
    countryName: 'Colombia',
    countryCode: 'co',
    translations: {
      dk: 'Colombia',
      en: 'Colombia',
      sv: 'Colombia',
      no: 'Colombia',
    },
    dialCode: 57,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Comoros (جزر القمر)',
    countryCode: 'km',
    translations: {
      dk: 'Comorerne',
      en: 'Comoros',
      sv: 'Komorerna',
      no: 'Komorene',
    },
    dialCode: 269,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
    countryCode: 'cd',
    translations: {
      dk: 'Congo (DRC)',
      en: 'Congo (DRC)',
      sv: 'Kongo (DRC)',
      no: 'Kongo (DRC)',
    },
    dialCode: 243,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Congo (Republic) (Congo-Brazzaville)',
    countryCode: 'cg',
    translations: {
      dk: 'Congo (Republikken)',
      en: 'Congo (Republic)',
      sv: 'Kongo (Republiken)',
      no: 'Kongo (Republikken)',
    },
    dialCode: 242,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Cook Islands',
    countryCode: 'ck',
    translations: {
      dk: 'Cookøerne',
      en: 'Cook Islands',
      sv: 'Cooköarna',
      no: 'Cookøyene',
    },
    dialCode: 682,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{5}$/,
  },
  {
    countryName: 'Costa Rica',
    countryCode: 'cr',
    translations: {
      dk: 'Costa Rica',
      en: 'Costa Rica',
      sv: 'Costa Rica',
      no: 'Costa Rica',
    },
    dialCode: 506,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Côte d’Ivoire',
    countryCode: 'ci',
    translations: {
      dk: 'Elfenbenskysten',
      en: 'Côte d’Ivoire',
      sv: 'Elfenbenskusten',
      no: 'Elfenbenskysten',
    },
    dialCode: 225,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Croatia (Hrvatska)',
    countryCode: 'hr',
    translations: {
      dk: 'Kroatien',
      en: 'Croatia',
      sv: 'Kroatien',
      no: 'Kroatia',
    },
    dialCode: 385,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Cuba',
    countryCode: 'cu',
    translations: {
      dk: 'Cuba',
      en: 'Cuba',
      sv: 'Kuba',
      no: 'Cuba',
    },
    dialCode: 53,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Curaçao',
    countryCode: 'cw',
    translations: {
      dk: 'Curaçao',
      en: 'Curaçao',
      sv: 'Curaçao',
      no: 'Curaçao',
    },
    dialCode: 599,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Cyprus (Κύπρος)',
    countryCode: 'cy',
    translations: {
      dk: 'Cypern',
      en: 'Cyprus',
      sv: 'Cypern',
      no: 'Kypros',
    },
    dialCode: 357,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Czech Republic (Česká republika)',
    countryCode: 'cz',
    translations: {
      dk: 'Tjekkiet',
      en: 'Czech Republic',
      sv: 'Tjeckien',
      no: 'Tsjekkia',
    },
    dialCode: 420,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Denmark (Danmark)',
    countryCode: 'dk',
    translations: {
      dk: 'Danmark',
      en: 'Denmark',
      sv: 'Danmark',
      no: 'Danmark',
    },
    dialCode: 45,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Djibouti',
    countryCode: 'dj',
    translations: {
      dk: 'Djibouti',
      en: 'Djibouti',
      sv: 'Djibouti',
      no: 'Djibouti',
    },
    dialCode: 253,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Dominica',
    countryCode: 'dm',
    translations: {
      dk: 'Dominica',
      en: 'Dominica',
      sv: 'Dominica',
      no: 'Dominica',
    },
    dialCode: 1,
    areaCodes: [767],
    priority: 13,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Dominican Republic (República Dominicana)',
    countryCode: 'do',
    translations: {
      dk: 'Den Dominikanske Republik',
      en: 'Dominican Republic',
      sv: 'Dominikanska republiken',
      no: 'Den dominikanske republikk',
    },
    dialCode: 1,
    areaCodes: [809, 829, 849],
    priority: 2,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Ecuador',
    countryCode: 'ec',
    translations: {
      dk: 'Ecuador',
      en: 'Ecuador',
      sv: 'Ecuador',
      no: 'Ecuador',
    },
    dialCode: 593,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Egypt (مصر)',
    countryCode: 'eg',
    translations: {
      dk: 'Egypten',
      en: 'Egypt',
      sv: 'Egypten',
      no: 'Egypt',
    },
    dialCode: 20,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'El Salvador',
    countryCode: 'sv',
    translations: {
      dk: 'El Salvador',
      en: 'El Salvador',
      sv: 'El Salvador',
      no: 'El Salvador',
    },
    dialCode: 503,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Equatorial Guinea (Guinea Ecuatorial)',
    countryCode: 'gq',
    translations: {
      dk: 'Ækvatorialguinea',
      en: 'Equatorial Guinea',
      sv: 'Ekvatorialguinea',
      no: 'Ekvatorial-Guinea',
    },
    dialCode: 240,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Eritrea',
    countryCode: 'er',
    translations: {
      dk: 'Eritrea',
      en: 'Eritrea',
      sv: 'Eritrea',
      no: 'Eritrea',
    },
    dialCode: 291,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Estonia (Eesti)',
    countryCode: 'ee',
    translations: {
      dk: 'Estland',
      en: 'Estonia',
      sv: 'Estland',
      no: 'Estland',
    },
    dialCode: 372,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Eswatini',
    countryCode: 'sz',
    translations: {
      dk: 'Eswatini',
      en: 'Eswatini',
      sv: 'Eswatini',
      no: 'Eswatini',
    },
    dialCode: 268,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Ethiopia',
    countryCode: 'et',
    translations: {
      dk: 'Etiopien',
      en: 'Ethiopia',
      sv: 'Etiopien',
      no: 'Etiopia',
    },
    dialCode: 251,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Falkland Islands (Islas Malvinas)',
    countryCode: 'fk',
    translations: {
      dk: 'Falklandsøerne',
      en: 'Falkland Islands',
      sv: 'Falklandsöarna',
      no: 'Falklandsøyene',
    },
    dialCode: 500,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Faroe Islands (Føroyar)',
    countryCode: 'fo',
    translations: {
      dk: 'Færøerne',
      en: 'Faroe Islands',
      sv: 'Färöarna',
      no: 'Færøyene',
    },
    dialCode: 298,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{6}$/,
  },
  {
    countryName: 'Fiji',
    countryCode: 'fj',
    translations: {
      dk: 'Fiji',
      en: 'Fiji',
      sv: 'Fiji',
      no: 'Fiji',
    },
    dialCode: 679,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Finland (Suomi)',
    countryCode: 'fi',
    translations: {
      dk: 'Finland',
      en: 'Finland',
      sv: 'Finland',
      no: 'Finland',
    },
    dialCode: 358,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'France',
    countryCode: 'fr',
    translations: {
      dk: 'Frankrig',
      en: 'France',
      sv: 'Frankrike',
      no: 'Frankrike',
    },
    dialCode: 33,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'French Guiana (Guyane française)',
    countryCode: 'gf',
    translations: {
      dk: 'Fransk Guyana',
      en: 'French Guiana',
      sv: 'Franska Guyana',
      no: 'Fransk Guyana',
    },
    dialCode: 594,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'French Polynesia (Polynésie française)',
    countryCode: 'pf',
    translations: {
      dk: 'Fransk Polynesien',
      en: 'French Polynesia',
      sv: 'Franska Polynesien',
      no: 'Fransk Polynesia',
    },
    dialCode: 689,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{6}$/,
  },
  {
    countryName: 'Gabon',
    countryCode: 'ga',
    translations: {
      dk: 'Gabon',
      en: 'Gabon',
      sv: 'Gabon',
      no: 'Gabon',
    },
    dialCode: 241,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Gambia',
    countryCode: 'gm',
    translations: {
      dk: 'Gambia',
      en: 'Gambia',
      sv: 'Gambia',
      no: 'Gambia',
    },
    dialCode: 220,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Georgia (საქართველო)',
    countryCode: 'ge',
    translations: {
      dk: 'Georgien',
      en: 'Georgia',
      sv: 'Georgien',
      no: 'Georgia',
    },
    dialCode: 995,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Germany (Deutschland)',
    countryCode: 'de',
    translations: {
      dk: 'Tyskland',
      en: 'Germany',
      sv: 'Tyskland',
      no: 'Tyskland',
    },
    dialCode: 49,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Ghana (Gaana)',
    countryCode: 'gh',
    translations: {
      dk: 'Ghana',
      en: 'Ghana',
      sv: 'Ghana',
      no: 'Ghana',
    },
    dialCode: 233,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Gibraltar',
    countryCode: 'gi',
    translations: {
      dk: 'Gibraltar',
      en: 'Gibraltar',
      sv: 'Gibraltar',
      no: 'Gibraltar',
    },
    dialCode: 350,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Greece (Ελλάδα)',
    countryCode: 'gr',
    translations: {
      dk: 'Grækenland',
      en: 'Greece',
      sv: 'Grekland',
      no: 'Hellas',
    },
    dialCode: 30,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Greenland (Kalaallit Nunaat)',
    countryCode: 'gl',
    translations: {
      dk: 'Grønland',
      en: 'Greenland',
      sv: 'Grönland',
      no: 'Grønland',
    },
    dialCode: 299,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{6}$/,
  },
  {
    countryName: 'Grenada',
    countryCode: 'gd',
    translations: {
      dk: 'Grenada',
      en: 'Grenada',
      sv: 'Grenada',
      no: 'Grenada',
    },
    dialCode: 1,
    areaCodes: [473],
    priority: 14,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Guadeloupe',
    countryCode: 'gp',
    translations: {
      dk: 'Guadeloupe',
      en: 'Guadeloupe',
      sv: 'Guadeloupe',
      no: 'Guadeloupe',
    },
    dialCode: 590,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Guam',
    countryCode: 'gu',
    translations: {
      dk: 'Guam',
      en: 'Guam',
      sv: 'Guam',
      no: 'Guam',
    },
    dialCode: 1,
    areaCodes: [671],
    priority: 15,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Guatemala',
    countryCode: 'gt',
    translations: {
      dk: 'Guatemala',
      en: 'Guatemala',
      sv: 'Guatemala',
      no: 'Guatemala',
    },
    dialCode: 502,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Guernsey',
    countryCode: 'gg',
    translations: {
      dk: 'Guernsey',
      en: 'Guernsey',
      sv: 'Guernsey',
      no: 'Guernsey',
    },
    dialCode: 44,
    areaCodes: [1481, 7781, 7839, 7911],
    priority: 1,
    regexpPhone: /^[0-9]{6,10}$/,
  },
  {
    countryName: 'Guinea (Guinée)',
    countryCode: 'gn',
    translations: {
      dk: 'Guinea',
      en: 'Guinea',
      sv: 'Guinea',
      no: 'Guinea',
    },
    dialCode: 224,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Guinea-Bissau (Guiné Bissau)',
    countryCode: 'gw',
    translations: {
      dk: 'Guinea-Bissau',
      en: 'Guinea-Bissau',
      sv: 'Guinea-Bissau',
      no: 'Guinea-Bissau',
    },
    dialCode: 245,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Guyana',
    countryCode: 'gy',
    translations: {
      dk: 'Guyana',
      en: 'Guyana',
      sv: 'Guyana',
      no: 'Guyana',
    },
    dialCode: 592,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Haiti',
    countryCode: 'ht',
    translations: {
      dk: 'Haiti',
      en: 'Haiti',
      sv: 'Haiti',
      no: 'Haiti',
    },
    dialCode: 509,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Honduras',
    countryCode: 'hn',
    translations: {
      dk: 'Honduras',
      en: 'Honduras',
      sv: 'Honduras',
      no: 'Honduras',
    },
    dialCode: 504,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Hong Kong (香港)',
    countryCode: 'hk',
    translations: {
      dk: 'Hongkong',
      en: 'Hong Kong',
      sv: 'Hongkong',
      no: 'Hongkong',
    },
    dialCode: 852,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Hungary (Magyarország)',
    countryCode: 'hu',
    translations: {
      dk: 'Ungarn',
      en: 'Hungary',
      sv: 'Ungern',
      no: 'Ungarn',
    },
    dialCode: 36,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Iceland (Ísland)',
    countryCode: 'is',
    translations: {
      dk: 'Island',
      en: 'Iceland',
      sv: 'Island',
      no: 'Island',
    },
    dialCode: 354,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'India (भारत)',
    countryCode: 'in',
    translations: {
      dk: 'Indien',
      en: 'India',
      sv: 'Indien',
      no: 'India',
    },
    dialCode: 91,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Indonesia',
    countryCode: 'id',
    translations: {
      dk: 'Indonesien',
      en: 'Indonesia',
      sv: 'Indonesien',
      no: 'Indonesia',
    },
    dialCode: 62,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Iran (ایران)',
    countryCode: 'ir',
    translations: {
      dk: 'Iran',
      en: 'Iran',
      sv: 'Iran',
      no: 'Iran',
    },
    dialCode: 98,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Iraq (العراق)',
    countryCode: 'iq',
    translations: {
      dk: 'Irak',
      en: 'Iraq',
      sv: 'Irak',
      no: 'Irak',
    },
    dialCode: 964,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Ireland',
    countryCode: 'ie',
    translations: {
      dk: 'Irland',
      en: 'Ireland',
      sv: 'Irland',
      no: 'Irland',
    },
    dialCode: 353,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Isle of Man',
    countryCode: 'im',
    translations: {
      dk: 'Isle of Man',
      en: 'Isle of Man',
      sv: 'Isle of Man',
      no: 'Isle of Man',
    },
    dialCode: 44,
    areaCodes: [1624, 74576, 7524, 7924, 7624],
    priority: 2,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Israel (ישראל)',
    countryCode: 'il',
    translations: {
      dk: 'Israel',
      en: 'Israel',
      sv: 'Israel',
      no: 'Israel',
    },
    dialCode: 972,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Italy (Italia)',
    countryCode: 'it',
    translations: {
      dk: 'Italien',
      en: 'Italy',
      sv: 'Italien',
      no: 'Italia',
    },
    dialCode: 39,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Jamaica',
    countryCode: 'jm',
    translations: {
      dk: 'Jamaica',
      en: 'Jamaica',
      sv: 'Jamaica',
      no: 'Jamaica',
    },
    dialCode: 1,
    areaCodes: [876, 658],
    priority: 4,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Japan (日本)',
    countryCode: 'jp',
    translations: {
      dk: 'Japan',
      en: 'Japan',
      sv: 'Japan',
      no: 'Japan',
    },
    dialCode: 81,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Jersey',
    countryCode: 'je',
    translations: {
      dk: 'Jersey',
      en: 'Jersey',
      sv: 'Jersey',
      no: 'Jersey',
    },
    dialCode: 44,
    areaCodes: [1534, 7509, 7700, 7797, 7829, 7937],
    priority: 3,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Jordan (الأردن)',
    countryCode: 'jo',
    translations: {
      dk: 'Jordan',
      en: 'Jordan',
      sv: 'Jordanien',
      no: 'Jordan',
    },
    dialCode: 962,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Kazakhstan (Казахстан)',
    countryCode: 'kz',
    translations: {
      dk: 'Kasakhstan',
      en: 'Kazakhstan',
      sv: 'Kazakstan',
      no: 'Kasakhstan',
    },
    dialCode: 7,
    areaCodes: [33, 7],
    priority: 1,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Kenya',
    countryCode: 'ke',
    translations: {
      dk: 'Kenya',
      en: 'Kenya',
      sv: 'Kenya',
      no: 'Kenya',
    },
    dialCode: 254,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Kiribati',
    countryCode: 'ki',
    translations: {
      dk: 'Kiribati',
      en: 'Kiribati',
      sv: 'Kiribati',
      no: 'Kiribati',
    },
    dialCode: 686,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Kosovo',
    countryCode: 'xk',
    translations: {
      dk: 'Kosovo',
      en: 'Kosovo',
      sv: 'Kosovo',
      no: 'Kosovo',
    },
    dialCode: 383,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Kuwait (الكويت)',
    countryCode: 'kw',
    translations: {
      dk: 'Kuwait',
      en: 'Kuwait',
      sv: 'Kuwait',
      no: 'Kuwait',
    },
    dialCode: 965,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Kyrgyzstan (Кыргызстан)',
    countryCode: 'kg',
    translations: {
      dk: 'Kirgisistan',
      en: 'Kyrgyzstan',
      sv: 'Kirgizistan',
      no: 'Kirgisistan',
    },
    dialCode: 996,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Laos (ລາວ)',
    countryCode: 'la',
    translations: {
      dk: 'Laos',
      en: 'Laos',
      sv: 'Laos',
      no: 'Laos',
    },
    dialCode: 856,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Latvia (Latvija)',
    countryCode: 'lv',
    translations: {
      dk: 'Letland',
      en: 'Latvia',
      sv: 'Lettland',
      no: 'Latvia',
    },
    dialCode: 371,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Lebanon (لبنان)',
    countryCode: 'lb',
    translations: {
      dk: 'Libanon',
      en: 'Lebanon',
      sv: 'Libanon',
      no: 'Libanon',
    },
    dialCode: 961,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7,8}$/,
  },
  {
    countryName: 'Lesotho',
    countryCode: 'ls',
    translations: {
      dk: 'Lesotho',
      en: 'Lesotho',
      sv: 'Lesotho',
      no: 'Lesotho',
    },
    dialCode: 266,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Liberia',
    countryCode: 'lr',
    translations: {
      dk: 'Liberia',
      en: 'Liberia',
      sv: 'Liberia',
      no: 'Liberia',
    },
    dialCode: 231,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7,8}$/,
  },
  {
    countryName: 'Libya (ليبيا)',
    countryCode: 'ly',
    translations: {
      dk: 'Libyen',
      en: 'Libya',
      sv: 'Libyen',
      no: 'Libya',
    },
    dialCode: 218,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Liechtenstein',
    countryCode: 'li',
    translations: {
      dk: 'Liechtenstein',
      en: 'Liechtenstein',
      sv: 'Liechtenstein',
      no: 'Liechtenstein',
    },
    dialCode: 423,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Lithuania (Lietuva)',
    countryCode: 'lt',
    translations: {
      dk: 'Litauen',
      en: 'Lithuania',
      sv: 'Litauen',
      no: 'Litauen',
    },
    dialCode: 370,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Luxembourg',
    countryCode: 'lu',
    translations: {
      dk: 'Luxembourg',
      en: 'Luxembourg',
      sv: 'Luxemburg',
      no: 'Luxembourg',
    },
    dialCode: 352,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Macau (澳門)',
    countryCode: 'mo',
    translations: {
      dk: 'Macao',
      en: 'Macau',
      sv: 'Macao',
      no: 'Macau',
    },
    dialCode: 853,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'North Macedonia (Македонија)',
    countryCode: 'mk',
    translations: {
      dk: 'Nordmakedonien',
      en: 'North Macedonia',
      sv: 'Nordmakedonien',
      no: 'Nord-Makedonia',
    },
    dialCode: 389,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Madagascar (Madagasikara)',
    countryCode: 'mg',
    translations: {
      dk: 'Madagaskar',
      en: 'Madagascar',
      sv: 'Madagaskar',
      no: 'Madagaskar',
    },
    dialCode: 261,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Malawi',
    countryCode: 'mw',
    translations: {
      dk: 'Malawi',
      en: 'Malawi',
      sv: 'Malawi',
      no: 'Malawi',
    },
    dialCode: 265,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Malaysia',
    countryCode: 'my',
    translations: {
      dk: 'Malaysia',
      en: 'Malaysia',
      sv: 'Malaysia',
      no: 'Malaysia',
    },
    dialCode: 60,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Maldives',
    countryCode: 'mv',
    translations: {
      dk: 'Maldiverne',
      en: 'Maldives',
      sv: 'Maldiverna',
      no: 'Maldivene',
    },
    dialCode: 960,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Mali',
    countryCode: 'ml',
    translations: {
      dk: 'Mali',
      en: 'Mali',
      sv: 'Mali',
      no: 'Mali',
    },
    dialCode: 223,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Malta',
    countryCode: 'mt',
    translations: {
      dk: 'Malta',
      en: 'Malta',
      sv: 'Malta',
      no: 'Malta',
    },
    dialCode: 356,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Marshall Islands',
    countryCode: 'mh',
    translations: {
      dk: 'Marshalløerne',
      en: 'Marshall Islands',
      sv: 'Marshallöarna',
      no: 'Marshalløyene',
    },
    dialCode: 692,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Martinique',
    countryCode: 'mq',
    translations: {
      dk: 'Martinique',
      en: 'Martinique',
      sv: 'Martinique',
      no: 'Martinique',
    },
    dialCode: 596,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Mauritania (موريتانيا)',
    countryCode: 'mr',
    translations: {
      dk: 'Mauretanien',
      en: 'Mauritania',
      sv: 'Mauretanien',
      no: 'Mauritania',
    },
    dialCode: 222,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Mauritius (Moris)',
    countryCode: 'mu',
    translations: {
      dk: 'Mauritius',
      en: 'Mauritius',
      sv: 'Mauritius',
      no: 'Mauritius',
    },
    dialCode: 230,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7,8}$/,
  },
  {
    countryName: 'Mayotte',
    countryCode: 'yt',
    translations: {
      dk: 'Mayotte',
      en: 'Mayotte',
      sv: 'Mayotte',
      no: 'Mayotte',
    },
    dialCode: 262,
    areaCodes: [269, 639],
    priority: 1,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Mexico (México)',
    countryCode: 'mx',
    translations: {
      dk: 'Mexico',
      en: 'Mexico',
      sv: 'Mexiko',
      no: 'Mexico',
    },
    dialCode: 52,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Micronesia',
    countryCode: 'fm',
    translations: {
      dk: 'Mikronesien',
      en: 'Micronesia',
      sv: 'Mikronesien',
      no: 'Mikronesia',
    },
    dialCode: 691,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Moldova (Republica Moldova)',
    countryCode: 'md',
    translations: {
      dk: 'Moldova',
      en: 'Moldova',
      sv: 'Moldavien',
      no: 'Moldova',
    },
    dialCode: 373,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Monaco',
    countryCode: 'mc',
    translations: {
      dk: 'Monaco',
      en: 'Monaco',
      sv: 'Monaco',
      no: 'Monaco',
    },
    dialCode: 377,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Mongolia (Монгол)',
    countryCode: 'mn',
    translations: {
      dk: 'Mongoliet',
      en: 'Mongolia',
      sv: 'Mongoliet',
      no: 'Mongolia',
    },
    dialCode: 976,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Montenegro (Crna Gora)',
    countryCode: 'me',
    translations: {
      dk: 'Montenegro',
      en: 'Montenegro',
      sv: 'Montenegro',
      no: 'Montenegro',
    },
    dialCode: 382,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Montserrat',
    countryCode: 'ms',
    translations: {
      dk: 'Montserrat',
      en: 'Montserrat',
      sv: 'Montserrat',
      no: 'Montserrat',
    },
    dialCode: 1,
    areaCodes: [664],
    priority: 16,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Morocco (المغرب)',
    countryCode: 'ma',
    translations: {
      dk: 'Marokko',
      en: 'Morocco',
      sv: 'Marocko',
      no: 'Marokko',
    },
    dialCode: 212,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Mozambique (Moçambique)',
    countryCode: 'mz',
    translations: {
      dk: 'Mozambique',
      en: 'Mozambique',
      sv: 'Moçambique',
      no: 'Mosambik',
    },
    dialCode: 258,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Myanmar (Burma) (မြန်မာ)',
    countryCode: 'mm',
    translations: {
      dk: 'Myanmar',
      en: 'Myanmar',
      sv: 'Myanmar',
      no: 'Myanmar',
    },
    dialCode: 95,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Namibia (Namibië)',
    countryCode: 'na',
    translations: {
      dk: 'Namibia',
      en: 'Namibia',
      sv: 'Namibia',
      no: 'Namibia',
    },
    dialCode: 264,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Nauru',
    countryCode: 'nr',
    translations: {
      dk: 'Nauru',
      en: 'Nauru',
      sv: 'Nauru',
      no: 'Nauru',
    },
    dialCode: 674,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Nepal (नेपाल)',
    countryCode: 'np',
    translations: {
      dk: 'Nepal',
      en: 'Nepal',
      sv: 'Nepal',
      no: 'Nepal',
    },
    dialCode: 977,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Netherlands (Nederland)',
    countryCode: 'nl',
    translations: {
      dk: 'Holland',
      en: 'Netherlands',
      sv: 'Nederländerna',
      no: 'Nederland',
    },
    dialCode: 31,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'New Caledonia (Nouvelle-Calédonie)',
    countryCode: 'nc',
    translations: {
      dk: 'Ny Kaledonien',
      en: 'New Caledonia',
      sv: 'Nya Kaledonien',
      no: 'Ny-Caledonia',
    },
    dialCode: 687,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{6}$/,
  },
  {
    countryName: 'New Zealand',
    countryCode: 'nz',
    translations: {
      dk: 'New Zealand',
      en: 'New Zealand',
      sv: 'Nya Zeeland',
      no: 'New Zealand',
    },
    dialCode: 64,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Nicaragua',
    countryCode: 'ni',
    translations: {
      dk: 'Nicaragua',
      en: 'Nicaragua',
      sv: 'Nicaragua',
      no: 'Nicaragua',
    },
    dialCode: 505,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Niger (Nijar)',
    countryCode: 'ne',
    translations: {
      dk: 'Niger',
      en: 'Niger',
      sv: 'Niger',
      no: 'Niger',
    },
    dialCode: 227,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Nigeria',
    countryCode: 'ng',
    translations: {
      dk: 'Nigeria',
      en: 'Nigeria',
      sv: 'Nigeria',
      no: 'Nigeria',
    },
    dialCode: 234,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Niue',
    countryCode: 'nu',
    translations: {
      dk: 'Niue',
      en: 'Niue',
      sv: 'Niue',
      no: 'Niue',
    },
    dialCode: 683,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{4}$/,
  },
  {
    countryName: 'Norfolk Island',
    countryCode: 'nf',
    translations: {
      dk: 'Norfolkøen',
      en: 'Norfolk Island',
      sv: 'Norfolkön',
      no: 'Norfolkøya',
    },
    dialCode: 672,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{6}$/,
  },
  {
    countryName: 'North Korea (조선 민주주의 인민 공화국)',
    countryCode: 'kp',
    translations: {
      dk: 'Nordkorea',
      en: 'North Korea',
      sv: 'Nordkorea',
      no: 'Nord-Korea',
    },
    dialCode: 850,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Northern Mariana Islands',
    countryCode: 'mp',
    translations: {
      dk: 'Nordmarianerne',
      en: 'Northern Mariana Islands',
      sv: 'Nordmarianerna',
      no: 'Nord-Marianene',
    },
    dialCode: 1,
    areaCodes: [670],
    priority: 17,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Norway (Norge)',
    countryCode: 'no',
    translations: {
      dk: 'Norge',
      en: 'Norway',
      sv: 'Norge',
      no: 'Norge',
    },
    dialCode: 47,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Oman (عُمان)',
    countryCode: 'om',
    translations: {
      dk: 'Oman',
      en: 'Oman',
      sv: 'Oman',
      no: 'Oman',
    },
    dialCode: 968,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Pakistan (پاکستان)',
    countryCode: 'pk',
    translations: {
      dk: 'Pakistan',
      en: 'Pakistan',
      sv: 'Pakistan',
      no: 'Pakistan',
    },
    dialCode: 92,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Palau',
    countryCode: 'pw',
    translations: {
      dk: 'Palau',
      en: 'Palau',
      sv: 'Palau',
      no: 'Palau',
    },
    dialCode: 680,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Palestine (فلسطين)',
    countryCode: 'ps',
    translations: {
      dk: 'Palæstina',
      en: 'Palestine',
      sv: 'Palestina',
      no: 'Palestina',
    },
    dialCode: 970,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Panama (Panamá)',
    countryCode: 'pa',
    translations: {
      dk: 'Panama',
      en: 'Panama',
      sv: 'Panama',
      no: 'Panama',
    },
    dialCode: 507,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Papua New Guinea',
    countryCode: 'pg',
    translations: {
      dk: 'Papua Ny Guinea',
      en: 'Papua New Guinea',
      sv: 'Papua Nya Guinea',
      no: 'Papua Ny-Guinea',
    },
    dialCode: 675,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Paraguay',
    countryCode: 'py',
    translations: {
      dk: 'Paraguay',
      en: 'Paraguay',
      sv: 'Paraguay',
      no: 'Paraguay',
    },
    dialCode: 595,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Peru (Perú)',
    countryCode: 'pe',
    translations: {
      dk: 'Peru',
      en: 'Peru',
      sv: 'Peru',
      no: 'Peru',
    },
    dialCode: 51,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Philippines',
    countryCode: 'ph',
    translations: {
      dk: 'Filippinerne',
      en: 'Philippines',
      sv: 'Filippinerna',
      no: 'Filippinene',
    },
    dialCode: 63,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Poland (Polska)',
    countryCode: 'pl',
    translations: {
      dk: 'Polen',
      en: 'Poland',
      sv: 'Polen',
      no: 'Polen',
    },
    dialCode: 48,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Portugal',
    countryCode: 'pt',
    translations: {
      dk: 'Portugal',
      en: 'Portugal',
      sv: 'Portugal',
      no: 'Portugal',
    },
    dialCode: 351,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Puerto Rico',
    countryCode: 'pr',
    translations: {
      dk: 'Puerto Rico',
      en: 'Puerto Rico',
      sv: 'Puerto Rico',
      no: 'Puerto Rico',
    },
    dialCode: 1,
    areaCodes: [787, 939],
    priority: 3,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Qatar (قطر)',
    countryCode: 'qa',
    translations: {
      dk: 'Qatar',
      en: 'Qatar',
      sv: 'Qatar',
      no: 'Qatar',
    },
    dialCode: 974,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Réunion (La Réunion)',
    countryCode: 're',
    translations: {
      dk: 'Réunion',
      en: 'Réunion',
      sv: 'Réunion',
      no: 'Réunion',
    },
    dialCode: 262,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Romania (România)',
    countryCode: 'ro',
    translations: {
      dk: 'Rumænien',
      en: 'Romania',
      sv: 'Rumänien',
      no: 'Romania',
    },
    dialCode: 40,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Russia (Россия)',
    countryCode: 'ru',
    translations: {
      dk: 'Rusland',
      en: 'Russia',
      sv: 'Ryssland',
      no: 'Russland',
    },
    dialCode: 7,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'Rwanda',
    countryCode: 'rw',
    translations: {
      dk: 'Rwanda',
      en: 'Rwanda',
      sv: 'Rwanda',
      no: 'Rwanda',
    },
    dialCode: 250,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Saint Barthélemy',
    countryCode: 'bl',
    translations: {
      dk: 'Saint Barthélemy',
      en: 'Saint Barthélemy',
      sv: 'Saint Barthélemy',
      no: 'Saint Barthélemy',
    },
    dialCode: 590,
    areaCodes: [],
    priority: 1,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Saint Helena',
    countryCode: 'sh',
    translations: {
      dk: 'Saint Helena',
      en: 'Saint Helena',
      sv: 'Saint Helena',
      no: 'Saint Helena',
    },
    dialCode: 290,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{4}$/,
  },
  {
    countryName: 'Saint Kitts and Nevis',
    countryCode: 'kn',
    translations: {
      dk: 'Saint Kitts og Nevis',
      en: 'Saint Kitts and Nevis',
      sv: 'Saint Kitts och Nevis',
      no: 'Saint Kitts og Nevis',
    },
    dialCode: 1,
    areaCodes: [869],
    priority: 18,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Saint Lucia',
    countryCode: 'lc',
    translations: {
      dk: 'Saint Lucia',
      en: 'Saint Lucia',
      sv: 'Saint Lucia',
      no: 'Saint Lucia',
    },
    dialCode: 1,
    areaCodes: [758],
    priority: 19,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Saint Martin (Saint-Martin (partie française))',
    countryCode: 'mf',
    translations: {
      dk: 'Saint Martin (Saint-Martin (partie française))',
      en: 'Saint Martin (Saint-Martin (French part))',
      sv: 'Saint Martin (Saint-Martin (franska delen))',
      no: 'Saint Martin (Saint-Martin (fransk del))',
    },
    dialCode: 590,
    areaCodes: [],
    priority: 2,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    countryCode: 'pm',
    translations: {
      dk: 'Saint Pierre og Miquelon',
      en: 'Saint Pierre and Miquelon',
      sv: 'Saint Pierre och Miquelon',
      no: 'Saint Pierre og Miquelon',
    },
    dialCode: 508,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{6}$/,
  },
  {
    countryName: 'Saint Vincent and the Grenadines',
    countryCode: 'vc',
    translations: {
      dk: 'Saint Vincent og Grenadinerne',
      en: 'Saint Vincent and the Grenadines',
      sv: 'Saint Vincent och Grenadinerna',
      no: 'Saint Vincent og Grenadinene',
    },
    dialCode: 1,
    areaCodes: [784],
    priority: 20,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Samoa',
    countryCode: 'ws',
    translations: {
      dk: 'Samoa',
      en: 'Samoa',
      sv: 'Samoa',
      no: 'Samoa',
    },
    dialCode: 685,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{5}$/,
  },
  {
    countryName: 'San Marino',
    countryCode: 'sm',
    translations: {
      dk: 'San Marino',
      en: 'San Marino',
      sv: 'San Marino',
      no: 'San Marino',
    },
    dialCode: 378,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'São Tomé and Príncipe (São Tomé e Príncipe)',
    countryCode: 'st',
    translations: {
      dk: 'São Tomé og Príncipe',
      en: 'São Tomé and Príncipe',
      sv: 'São Tomé och Príncipe',
      no: 'São Tomé og Príncipe',
    },
    dialCode: 239,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Saudi Arabia (المملكة العربية السعودية)',
    countryCode: 'sa',
    translations: {
      dk: 'Saudi-Arabien',
      en: 'Saudi Arabia',
      sv: 'Saudiarabien',
      no: 'Saudi-Arabia',
    },
    dialCode: 966,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Senegal (Sénégal)',
    countryCode: 'sn',
    translations: {
      dk: 'Senegal',
      en: 'Senegal',
      sv: 'Senegal',
      no: 'Senegal',
    },
    dialCode: 221,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Serbia (Србија)',
    countryCode: 'rs',
    translations: {
      dk: 'Serbien',
      en: 'Serbia',
      sv: 'Serbien',
      no: 'Serbia',
    },
    dialCode: 381,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Seychelles',
    countryCode: 'sc',
    translations: {
      dk: 'Seychellerne',
      en: 'Seychelles',
      sv: 'Seychellerna',
      no: 'Seychellene',
    },
    dialCode: 248,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Sierra Leone',
    countryCode: 'sl',
    translations: {
      dk: 'Sierra Leone',
      en: 'Sierra Leone',
      sv: 'Sierra Leone',
      no: 'Sierra Leone',
    },
    dialCode: 232,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Singapore',
    countryCode: 'sg',
    translations: {
      dk: 'Singapore',
      en: 'Singapore',
      sv: 'Singapore',
      no: 'Singapore',
    },
    dialCode: 65,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Sint Maarten',
    countryCode: 'sx',
    translations: {
      dk: 'Sint Maarten',
      en: 'Sint Maarten',
      sv: 'Sint Maarten',
      no: 'Sint Maarten',
    },
    dialCode: 1,
    areaCodes: [721],
    priority: 21,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Slovakia (Slovensko)',
    countryCode: 'sk',
    translations: {
      dk: 'Slovakiet',
      en: 'Slovakia',
      sv: 'Slovakien',
      no: 'Slovakia',
    },
    dialCode: 421,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Slovenia (Slovenija)',
    countryCode: 'si',
    translations: {
      dk: 'Slovenien',
      en: 'Slovenia',
      sv: 'Slovenien',
      no: 'Slovenia',
    },
    dialCode: 386,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Solomon Islands',
    countryCode: 'sb',
    translations: {
      dk: 'Salomonøerne',
      en: 'Solomon Islands',
      sv: 'Salomonöarna',
      no: 'Salomonøyene',
    },
    dialCode: 677,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{5}$/,
  },
  {
    countryName: 'Somalia (Soomaaliya)',
    countryCode: 'so',
    translations: {
      dk: 'Somalia',
      en: 'Somalia',
      sv: 'Somalia',
      no: 'Somalia',
    },
    dialCode: 252,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'South Africa',
    countryCode: 'za',
    translations: {
      dk: 'Sydafrika',
      en: 'South Africa',
      sv: 'Sydafrika',
      no: 'Sør-Afrika',
    },
    dialCode: 27,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'South Korea (대한민국)',
    countryCode: 'kr',
    translations: {
      dk: 'Sydkorea',
      en: 'South Korea',
      sv: 'Sydkorea',
      no: 'Sør-Korea',
    },
    dialCode: 82,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{10}$/,
  },
  {
    countryName: 'South Sudan (جنوب السودان)',
    countryCode: 'ss',
    translations: {
      dk: 'Sydsudan',
      en: 'South Sudan',
      sv: 'Sydsudan',
      no: 'Sør-Sudan',
    },
    dialCode: 211,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Spain (España)',
    countryCode: 'es',
    translations: {
      dk: 'Spanien',
      en: 'Spain',
      sv: 'Spanien',
      no: 'Spania',
    },
    dialCode: 34,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Sri Lanka (ශ්‍රී ලංකාව)',
    countryCode: 'lk',
    translations: {
      dk: 'Sri Lanka',
      en: 'Sri Lanka',
      sv: 'Sri Lanka',
      no: 'Sri Lanka',
    },
    dialCode: 94,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Sudan (السودان)',
    countryCode: 'sd',
    translations: {
      dk: 'Sudan',
      en: 'Sudan',
      sv: 'Sudan',
      no: 'Sudan',
    },
    dialCode: 249,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Suriname',
    countryCode: 'sr',
    translations: {
      dk: 'Surinam',
      en: 'Suriname',
      sv: 'Surinam',
      no: 'Surinam',
    },
    dialCode: 597,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Svalbard and Jan Mayen',
    countryCode: 'sj',
    translations: {
      dk: 'Svalbard og Jan Mayen',
      en: 'Svalbard and Jan Mayen',
      sv: 'Svalbard och Jan Mayen',
      no: 'Svalbard og Jan Mayen',
    },
    dialCode: 47,
    areaCodes: [79],
    priority: 1,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Sweden (Sverige)',
    countryCode: 'se',
    translations: {
      dk: 'Sverige',
      en: 'Sweden',
      sv: 'Sverige',
      no: 'Sverige',
    },
    dialCode: 46,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Switzerland (Schweiz)',
    countryCode: 'ch',
    translations: {
      dk: 'Schweiz',
      en: 'Switzerland',
      sv: 'Schweiz',
      no: 'Sveits',
    },
    dialCode: 41,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Syria (سوريا)',
    countryCode: 'sy',
    translations: {
      dk: 'Syrien',
      en: 'Syria',
      sv: 'Syrien',
      no: 'Syria',
    },
    dialCode: 963,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Taiwan (台灣)',
    countryCode: 'tw',
    translations: {
      dk: 'Taiwan',
      en: 'Taiwan',
      sv: 'Taiwan',
      no: 'Taiwan',
    },
    dialCode: 886,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Tajikistan',
    countryCode: 'tj',
    translations: {
      dk: 'Tadsjikistan',
      en: 'Tajikistan',
      sv: 'Tadzjikistan',
      no: 'Tadsjikistan',
    },
    dialCode: 992,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Tanzania',
    countryCode: 'tz',
    translations: {
      dk: 'Tanzania',
      en: 'Tanzania',
      sv: 'Tanzania',
      no: 'Tanzania',
    },
    dialCode: 255,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Thailand (ไทย)',
    countryCode: 'th',
    translations: {
      dk: 'Thailand',
      en: 'Thailand',
      sv: 'Thailand',
      no: 'Thailand',
    },
    dialCode: 66,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{9}$/,
  },
  {
    countryName: 'Timor-Leste',
    countryCode: 'tl',
    translations: {
      dk: 'Østtimor',
      en: 'Timor-Leste',
      sv: 'Östtimor',
      no: 'Øst-Timor',
    },
    dialCode: 670,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Togo',
    countryCode: 'tg',
    translations: {
      dk: 'Togo',
      en: 'Togo',
      sv: 'Togo',
      no: 'Togo',
    },
    dialCode: 228,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Tokelau',
    countryCode: 'tk',
    translations: {
      dk: 'Tokelau',
      en: 'Tokelau',
      sv: 'Tokelau',
      no: 'Tokelau',
    },
    dialCode: 690,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{4}$/,
  },
  {
    countryName: 'Tonga',
    countryCode: 'to',
    translations: {
      dk: 'Tonga',
      en: 'Tonga',
      sv: 'Tonga',
      no: 'Tonga',
    },
    dialCode: 676,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{5}$/,
  },
  {
    countryName: 'Trinidad and Tobago',
    countryCode: 'tt',
    translations: {
      dk: 'Trinidad og Tobago',
      en: 'Trinidad and Tobago',
      sv: 'Trinidad och Tobago',
      no: 'Trinidad og Tobago',
    },
    dialCode: 1,
    areaCodes: [868],
    priority: 22,
    regexpPhone: /^[0-9]{7}$/,
  },
  {
    countryName: 'Tunisia (تونس)',
    countryCode: 'tn',
    translations: {
      dk: 'Tunesien',
      en: 'Tunisia',
      sv: 'Tunisien',
      no: 'Tunisia',
    },
    dialCode: 216,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^[0-9]{8}$/,
  },
  {
    countryName: 'Turkey (Türkiye)',
    countryCode: 'tr',
    translations: {
      dk: 'Tyrkiet',
      en: 'Turkey',
      sv: 'Turkiet',
      no: 'Tyrkia',
    },
    dialCode: 90,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{10}$/,
  },
  {
    countryName: 'Turkmenistan',
    countryCode: 'tm',
    translations: {
      dk: 'Turkmenistan',
      en: 'Turkmenistan',
      sv: 'Turkmenistan',
      no: 'Turkmenistan',
    },
    dialCode: 993,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{8}$/,
  },
  {
    countryName: 'Turks and Caicos Islands',
    countryCode: 'tc',
    translations: {
      dk: 'Turks- og Caicosøerne',
      en: 'Turks and Caicos Islands',
      sv: 'Turks- och Caicosöarna',
      no: 'Turks- og Caicosøyene',
    },
    dialCode: 1,
    areaCodes: [649],
    priority: 23,
    regexpPhone: /^\d{7}$/,
  },
  {
    countryName: 'Tuvalu',
    countryCode: 'tv',
    translations: {
      dk: 'Tuvalu',
      en: 'Tuvalu',
      sv: 'Tuvalu',
      no: 'Tuvalu',
    },
    dialCode: 688,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{5}$/,
  },
  {
    countryName: 'U.S. Virgin Islands',
    countryCode: 'vi',
    translations: {
      dk: 'De Amerikanske Jomfruøer',
      en: 'U.S. Virgin Islands',
      sv: 'Amerikanska Jungfruöarna',
      no: 'De amerikanske jomfruøyene',
    },
    dialCode: 1,
    areaCodes: [340],
    priority: 24,
    regexpPhone: /^\d{7}$/,
  },
  {
    countryName: 'Uganda',
    countryCode: 'ug',
    translations: {
      dk: 'Uganda',
      en: 'Uganda',
      sv: 'Uganda',
      no: 'Uganda',
    },
    dialCode: 256,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{9}$/,
  },
  {
    countryName: 'Ukraine (Україна)',
    countryCode: 'ua',
    translations: {
      dk: 'Ukraine',
      en: 'Ukraine',
      sv: 'Ukraina',
      no: 'Ukraina',
    },
    dialCode: 380,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{9}$/,
  },
  {
    countryName: 'United Arab Emirates (الإمارات العربية المتحدة)',
    countryCode: 'ae',
    translations: {
      dk: 'Forenede Arabiske Emirater',
      en: 'United Arab Emirates',
      sv: 'Förenade Arabemiraten',
      no: 'De forente arabiske emirater',
    },
    dialCode: 971,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{8}$/,
  },
  {
    countryName: 'United Kingdom',
    countryCode: 'gb',
    translations: {
      dk: 'Storbritannien',
      en: 'United Kingdom',
      sv: 'Storbritannien',
      no: 'Storbritannia',
    },
    dialCode: 44,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{10}$/,
  },
  {
    countryName: 'United States',
    countryCode: 'us',
    translations: {
      dk: 'USA',
      en: 'United States',
      sv: 'USA',
      no: 'USA',
    },
    dialCode: 1,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{10}$/,
  },
  {
    countryName: 'Uruguay',
    countryCode: 'uy',
    translations: {
      dk: 'Uruguay',
      en: 'Uruguay',
      sv: 'Uruguay',
      no: 'Uruguay',
    },
    dialCode: 598,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{8}$/,
  },
  {
    countryName: 'Uzbekistan (Oʻzbekiston)',
    countryCode: 'uz',
    translations: {
      dk: 'Usbekistan',
      en: 'Uzbekistan',
      sv: 'Uzbekistan',
      no: 'Usbekistan',
    },
    dialCode: 998,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{9}$/,
  },
  {
    countryName: 'Vanuatu',
    countryCode: 'vu',
    translations: {
      dk: 'Vanuatu',
      en: 'Vanuatu',
      sv: 'Vanuatu',
      no: 'Vanuatu',
    },
    dialCode: 678,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{7}$/,
  },
  {
    countryName: 'Vatican City (Città del Vaticano)',
    countryCode: 'va',
    translations: {
      dk: 'Vatikanstaten',
      en: 'Vatican City',
      sv: 'Vatikanstaten',
      no: 'Vatikanstaten',
    },
    dialCode: 39,
    areaCodes: [6698],
    priority: 1,
    regexpPhone: /^\d{5}$/,
  },
  {
    countryName: 'Venezuela',
    countryCode: 've',
    translations: {
      dk: 'Venezuela',
      en: 'Venezuela',
      sv: 'Venezuela',
      no: 'Venezuela',
    },
    dialCode: 58,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{10}$/,
  },
  {
    countryName: 'Vietnam (Việt Nam)',
    countryCode: 'vn',
    translations: {
      dk: 'Vietnam',
      en: 'Vietnam',
      sv: 'Vietnam',
      no: 'Vietnam',
    },
    dialCode: 84,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{9}$/,
  },
  {
    countryName: 'Wallis and Futuna (Wallis-et-Futuna)',
    countryCode: 'wf',
    translations: {
      dk: 'Wallis og Futuna',
      en: 'Wallis and Futuna',
      sv: 'Wallis och Futuna',
      no: 'Wallis og Futuna',
    },
    dialCode: 681,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{6}$/,
  },
  {
    countryName: 'Western Sahara (الصحراء الغربية)',
    countryCode: 'eh',
    translations: {
      dk: 'Vestsahara',
      en: 'Western Sahara',
      sv: 'Västsahara',
      no: 'Vest-Sahara',
    },
    dialCode: 212,
    areaCodes: [5288, 5289],
    priority: 1,
    regexpPhone: /^\d{5}$/,
  },
  {
    countryName: 'Yemen (اليمن)',
    countryCode: 'ye',
    translations: {
      dk: 'Yemen',
      en: 'Yemen',
      sv: 'Jemen',
      no: 'Jemen',
    },
    dialCode: 967,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{9}$/,
  },
  {
    countryName: 'Zambia',
    countryCode: 'zm',
    translations: {
      dk: 'Zambia',
      en: 'Zambia',
      sv: 'Zambia',
      no: 'Zambia',
    },
    dialCode: 260,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{9}$/,
  },
  {
    countryName: 'Zimbabwe',
    countryCode: 'zw',
    translations: {
      dk: 'Zimbabwe',
      en: 'Zimbabwe',
      sv: 'Zimbabwe',
      no: 'Zimbabwe',
    },
    dialCode: 263,
    areaCodes: [],
    priority: 0,
    regexpPhone: /^\d{9}$/,
  },
  {
    countryName: 'Åland Islands',
    countryCode: 'ax',
    translations: {
      dk: 'Ålandsøerne',
      en: 'Åland Islands',
      sv: 'Åland',
      no: 'Åland',
    },
    dialCode: 358,
    areaCodes: [18],
    priority: 1,
    regexpPhone: /^\d{5}$/,
  },
];

const defaultCountriesForPhone = countryList.map(country => ({
  name: country.countryName,
  iso2: country.countryCode,
  dialCode: country.dialCode,
  priority: country.priority,
  areaCodes: country.areaCodes,
}));

export { defaultCountriesForPhone };

export const getCountryList = (language: 'dk' | 'en' | 'sv' | 'no') => {
  const phoneList: {
    name: string;
    iso2: string;
    dialCode: number;
    priority: number;
    areaCodes: number[];
  }[] = [];

  countryList.forEach(r => {
    const { countryCode, dialCode, priority, areaCodes, translations } = r;

    const countryName = translations[language];

    phoneList.push({
      name: countryName,
      iso2: countryCode,
      dialCode,
      priority,
      areaCodes,
    });
  });

  return phoneList;
};
